/**
 * Player Scoring Adapter
 *
 * Transforms scoring question data into PlayerScoringQuestion component props
 */

import type { ScoringQuestionData } from '../types';

/**
 * PlayerScoringQuestion component props
 */
export interface PlayerScoringQuestionProps {
  questionText: string;
  questionSubtext?: string;
  questionNumber?: number;
  statTypeCode?: string | null;
  options: Array<{
    option_id?: string;
    option_text_en: string;
    option_text_fr?: string;
    option_image_en?: string | null;
    option_image_fr?: string | null;
    third_image_en?: string | null;
    third_image_fr?: string | null;
    is_correct: boolean;
    points?: number;
    selectionCount?: number;
    stats?: any;
  }>;
  points: number;
  status?: 'LIVE' | 'FINAL' | 'SCHEDULED';
}

/**
 * Transforms scoring data into PlayerScoringQuestion props
 *
 * @param data - Scoring question data
 * @returns PlayerScoringQuestion component props
 */
export function playerScoringAdapter(data: ScoringQuestionData): PlayerScoringQuestionProps {
  return {
    questionText: data.questionText,
    questionSubtext: data.questionSubtext,
    questionNumber: data.questionNumber,
    statTypeCode: data.statTypeCode ?? null,
    options: data.options.map(opt => ({
      option_id: opt.option_id,
      option_text_en: opt.option_text_en,
      option_text_fr: opt.option_text_fr,
      option_image_en: opt.option_image_en,
      option_image_fr: opt.option_image_fr,
      third_image_en: opt.third_image_en,
      third_image_fr: opt.third_image_fr,
      is_correct: opt.is_correct,
      points: opt.points,
      selectionCount: opt.selectionCount,
      stats: opt.stats,
      grading_data: opt.grading_data,
    })),
    points: data.totalPoints,
    status: data.status,
  };
}
